export default __webpack_public_path__ + "static/media/redditto.267df73e.png";